// extracted by mini-css-extract-plugin
export default {"contents":"RF-z","sectionHeading":"SF-z"};